import React from 'react'

export default function HeroSection() {
  return (
    <div className='sustainability-hero-section d-flex justify-content-center align-items-center'>
      <p style={{fontSize:'2em', fontWeight:'500',color:'#FFF'}}>
        We are dedicated to building a sustainable future for our planet and<br />
        global economy, which is why we believe that everyone should look<br />
        for solutions that consume less resources or use it more efficiently.
      </p>
    </div>
  )
}
